import { fetchFromOldApi } from '~/services/Http';

export const putChangeAccountStatus = async (
  userName: string | undefined,
  json: string,
) => {
  return await fetchFromOldApi(`/json/user/${userName}/status`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};
